// import { format } from 'date-fns'
// import { message } from 'ant-design-vue';
// import 'ant-design-vue/es/message/style/css';

import { useHub } from '@/components/Hub/hub';

export function SCALE_IMG_URL(
  url: string,
  width: number,
  quality: number = 20
): string {
  return (
    url + '?imageMogr2/thumbnail/' + width + 'x/interlace/0/quality/' + quality
  );
}

export function isBlank(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  return false;
}

export function safeString(value: any): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
}

export function safeArray(value: any): Array<any> {
  let arr = value as Array<any>;
  if (value === null || arr === undefined) {
    return [];
  }
  return value;
}

export function isNotEmptyObject(obj: any): boolean {
  if (typeof obj === 'object') {
    if (Object.keys(obj).length > 0) {
      return true;
    }
  }
  return false;
}

export function formatTime(seconds: number): string {
  const s = Math.max(0, seconds);
  const minutes = Math.floor(s / 60);
  const remainingSeconds = s % 60;
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
}

export function formatSeconds(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (remainingSeconds == 0) {
    return `${minutes}分钟`;
  }
  return `${minutes}分${String(remainingSeconds).padStart(2, '0')}秒`;
}
export function isMobile(): boolean {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
}

export function isAndroid(): boolean {
  if (isMobile()) {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS === false) {
      return true;
    }
  }
  return false;
}

export function checkPlateformType() {
  //平台判断
  var browser = {
    versions: (function () {
      var u = navigator.userAgent;
      return {
        isApp: u.match(/Colgapp/i) ? true : false /*app终端*/,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) /*是否为移动终端*/,
        weixin: u.match(/micromessenger/i) ? true : false,
        QQbrw: u.indexOf('MQQBrowser') > -1, // QQ浏览器
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) /*ios终端*/,
        android: u.match(/Android/i) ? true : false,
      };
    })(),
    language: navigator.language.toLowerCase(),
  };
  return browser;
}

export function getQueryItem(name: string): string | undefined {
  let urlSearchParams = new URLSearchParams(window.location.search);
  const params: { [key: string]: string } = Array.from(urlSearchParams.entries()).reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {} as { [key: string]: string });
  return params[name];
}

export async function shareAction(
  title: string,
  url: string,
  image: string,
  description: string
): Promise<string> {
  const browser = checkPlateformType();
  if (browser.versions.isApp) {
    let shareObj = {
      // 0-QQ好友 1-QQ空间  2-微信 3-朋友圈
      shareType: [0, 1, 2, 3],
      title: title,
      url: url,
      image: image,
      description: description,
    };

    //@ts-ignore
    dsBridgeController('share', JSON.stringify(shareObj), function (res) {});
    return '';
  } else {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(url);
        return '复制成功';
      } catch (err) {
        return `复制失败${err}`;
      }
    } else {
      return '该浏览器不支持复制到剪贴板';
    }
  }
}

export const delay = (ms: number | undefined) =>
  new Promise((resolve, reject) => setTimeout(resolve, ms));

export function throttle(fn: (...arg: any[]) => any, interval: number = 300) {
  let lock = false;
  return function (this: unknown, ...args: any[]) {
    if (lock) return;
    lock = true;
    setTimeout(() => (lock = false), interval);
    fn.bind(this)(...args);
  };
}

/**
 * 判断某个原生DOM元素是否不在屏幕可见区内
 * @param {*} el 原生DOM元素
 */
export const isElementNotInViewport = function (el: any) {
  let rect = el?.value?.getBoundingClientRect();
  return (
    rect?.top + 230 >=
      (window?.innerHeight || document?.documentElement?.clientHeight) ||
    rect?.bottom <= 0
  );
};

//判断字符数
export const getLen = function (str: string) {
  const chinese = /[^\x00-\xff]/g;
  let newVal = str.replace(chinese, '**');
  return newVal.length;
};

export function ToastViewMessage(text: string) {
  // console.log(text);
  // message.config({
  //     top: '45vh'
  // })
  // message.open({
  //     content: () => text,
  //     // class: 'custom-class',
  //     style: {
  //         color: '#333333',
  //     },
  // })
}

export const addQueryToUrl = function (
  url: string,
  key: string,
  value: string
): string {
  let urlSearchParams = new URLSearchParams(url);
  urlSearchParams.append(key, value);
  return urlSearchParams.toString();
};

// declare global {
//     interface Date {
//         format(fmt: string): string;
//     }
// }

// Date.prototype.format = function (fmt) {
//     var o = {
//         "M+": this.getMonth() + 1,                 //月份
//         "D+": this.getDate(),                    //日
//         "h+": this.getHours(),                   //小时
//         "m+": this.getMinutes(),                 //分
//         "s+": this.getSeconds(),                 //秒
//         "q+": Math.floor((this.getMonth() + 3) / 3), //季度
//         "S": this.getMilliseconds()             //毫秒
//     }
//     if (/(Y+)/i.test(fmt)) {
//         fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
//     }
//     for (var k in o) {
//         if (new RegExp("(" + k + ")").test(fmt)) {
//             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
//         }
//     }
//     return fmt
// }

// export function datesFormat(timesStamp: string, datePattern: string = '') {
//     return (new Date(parseInt(timesStamp)).format(datePattern ? datePattern : 'YYYY-MM-DD hh:mm:ss'))
// }

export const Random = (max: any) => {
  return Math.floor(Math.random() * max) + 1;
};
